export const VENUE_ADMIN_VERIFIED_EVENT = 'muzone:venue-admin:verified';

function dispatchBrowserEvent(eventName, detail) {
    if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
        return;
    }
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
}

function subscribeBrowserEvent(eventName, handler) {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
        return () => {};
    }
    window.addEventListener(eventName, handler);
    return () => {
        window.removeEventListener(eventName, handler);
    };
}

export function emitVenueAdminVerified(payload = {}) {
    dispatchBrowserEvent(VENUE_ADMIN_VERIFIED_EVENT, {
        venueId: payload.venueId,
        venue: payload.venue,
    });
}

export function subscribeVenueAdminVerified(handler) {
    return subscribeBrowserEvent(VENUE_ADMIN_VERIFIED_EVENT, handler);
}
